function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.56,
    height: 7.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.93125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 3.725,
    fontFamily: "Arial"
  }, "\n        Keweenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.45,
    width: 19.56,
    height: 14.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 14.775,
    fontFamily: "Arial"
  }, "\n        Luce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.1,
    width: 19.56,
    height: 19.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1799999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 31.64,
    fontFamily: "Arial"
  }, "\n        Baraga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.17,
    width: 19.56,
    height: 21.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 52.025000000000006,
    fontFamily: "Arial"
  }, "\n        Ontonagon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.88,
    width: 19.56,
    height: 22.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 74.295,
    fontFamily: "Arial"
  }, "\n        Oscoda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85.71,
    width: 19.56,
    height: 22.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.778181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 97.205,
    fontFamily: "Arial"
  }, "\n        Schoolcraft\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 108.7,
    width: 19.56,
    height: 24.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 121.035,
    fontFamily: "Arial"
  }, "\n        Alger\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 133.38,
    width: 19.56,
    height: 27.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 146.96,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 160.54,
    width: 19.56,
    height: 28.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.778181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 174.94,
    fontFamily: "Arial"
  }, "\n        Montmorency\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 189.34,
    width: 19.56,
    height: 33.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 206.195,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 223.06,
    width: 19.56,
    height: 33.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 239.97,
    fontFamily: "Arial"
  }, "\n        Alcona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 256.87,
    width: 19.56,
    height: 34.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 273.955,
    fontFamily: "Arial"
  }, "\n        Mackinac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 291.04,
    width: 19.56,
    height: 37.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 309.77000000000004,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 328.5,
    width: 19.56,
    height: 38.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 347.71,
    fontFamily: "Arial"
  }, "\n        Missaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 366.93,
    width: 19.56,
    height: 38.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 386.39,
    fontFamily: "Arial"
  }, "\n        Presque_Isle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 405.85,
    width: 19.56,
    height: 42.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 427.12,
    fontFamily: "Arial"
  }, "\n        Arenac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 448.39,
    width: 19.56,
    height: 43.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 470.085,
    fontFamily: "Arial"
  }, "\n        Kalkaska\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 491.78,
    width: 19.56,
    height: 43.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.794285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 513.66,
    fontFamily: "Arial"
  }, "\n        Gogebic\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 535.54,
    width: 19.56,
    height: 50.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 560.855,
    fontFamily: "Arial"
  }, "\n        Benzie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 586.17,
    width: 19.56,
    height: 55.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 614.12,
    fontFamily: "Arial"
  }, "\n        Ogemaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 642.07,
    width: 19.56,
    height: 57.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.794285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 671.0350000000001,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 0,
    width: 30.95,
    height: 37.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4388888888888887
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.035,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Menominee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.51,
    y: 0,
    width: 33.33,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.175,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Oceana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.84,
    y: 0,
    width: 33.36,
    height: 37.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.52000000000001,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.21,
    y: 0,
    width: 34.54,
    height: 37.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.48,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Manistee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.74,
    y: 0,
    width: 35.86,
    height: 37.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.122857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.67000000000002,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Gladwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.6,
    y: 0,
    width: 36.73,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.0811111111111105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.965,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Dickinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.33,
    y: 0,
    width: 36.92,
    height: 37.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.153333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.79000000000002,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Antrim\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.24,
    y: 0,
    width: 37.64,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.06,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Cheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.89,
    y: 0,
    width: 37.73,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.755,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Leelanau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 0,
    width: 37.97,
    height: 37.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.605,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Iosco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.58,
    y: 0,
    width: 38.33,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7350000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.745,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Charlevoix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.91,
    y: 0,
    width: 38.56,
    height: 37.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.19000000000005,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Clare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.47,
    y: 0,
    width: 38.92,
    height: 37.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.93,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Roscommon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.4,
    y: 0,
    width: 39.61,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.205,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.01,
    y: 0,
    width: 41.1,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.335714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.56,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Wexford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.1,
    y: 0,
    width: 41.23,
    height: 37.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.715,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Alpena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.34,
    y: 0,
    width: 42.97,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 633.825,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Houghton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 655.3,
    y: 0,
    width: 44.7,
    height: 37.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.65,
    y: 18.675,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 37.35,
    width: 45.46,
    height: 38.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7379999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 56.695,
    fontFamily: "Arial"
  }, "\n        Emmet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 76.04,
    width: 45.46,
    height: 38.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 95.39500000000001,
    fontFamily: "Arial"
  }, "\n        Gratiot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 114.75,
    width: 45.46,
    height: 38.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.779999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 134.2,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 153.65,
    width: 45.46,
    height: 39.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.594285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 173.23000000000002,
    fontFamily: "Arial"
  }, "\n        Mecosta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 192.8,
    width: 45.46,
    height: 40.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.670000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 212.81,
    fontFamily: "Arial"
  }, "\n        Branch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 232.82,
    width: 45.46,
    height: 42.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 254.245,
    fontFamily: "Arial"
  }, "\n        Delta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 275.66,
    width: 45.46,
    height: 45.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.002222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 298.17,
    fontFamily: "Arial"
  }, "\n        Hillsdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 320.69,
    width: 45.46,
    height: 46.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.494285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 343.81,
    fontFamily: "Arial"
  }, "\n        Sanilac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 366.93,
    width: 45.46,
    height: 50.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 392.205,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 417.48,
    width: 45.46,
    height: 50.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.494285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 442.95000000000005,
    fontFamily: "Arial"
  }, "\n        Newaygo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 468.42,
    width: 45.46,
    height: 54.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 495.58000000000004,
    fontFamily: "Arial"
  }, "\n        Isabella\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 522.74,
    width: 45.46,
    height: 56.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 550.845,
    fontFamily: "Arial"
  }, "\n        St._Joseph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 578.95,
    width: 45.46,
    height: 59.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 608.72,
    fontFamily: "Arial"
  }, "\n        Montcalm\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 638.49,
    width: 45.46,
    height: 61.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.29,
    y: 669.245,
    fontFamily: "Arial"
  }, "\n        Ionia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 37.35,
    width: 47.31,
    height: 60.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.758571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.675,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Tuscola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.33,
    y: 37.35,
    width: 50.54,
    height: 60.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.6,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Barry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.87,
    y: 37.35,
    width: 54.24,
    height: 60.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.026666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.99,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 37.35,
    width: 57.05,
    height: 60.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.338888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.625,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Van_Buren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.15,
    y: 37.35,
    width: 61.19,
    height: 60.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0649999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.745,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Shiawassee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.34,
    y: 37.35,
    width: 63.12,
    height: 60.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.9,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.46,
    y: 37.35,
    width: 72.25,
    height: 60.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.585,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Midland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.7,
    y: 37.35,
    width: 73.7,
    height: 60.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.108333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.55,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Lapeer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.4,
    y: 37.35,
    width: 77.11,
    height: 60.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.332142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.9549999999999,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Grand_Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.52,
    y: 37.35,
    width: 78.48,
    height: 60.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.76,
    y: 67.675,
    fontFamily: "Arial"
  }, "\n        Lenawee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 98,
    width: 75.69,
    height: 72.12,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.302857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.865,
    y: 134.06,
    fontFamily: "Arial"
  }, "\n        Allegan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 170.12,
    width: 75.69,
    height: 74.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.918000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.865,
    y: 207.41500000000002,
    fontFamily: "Arial"
  }, "\n        Eaton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 244.71,
    width: 75.69,
    height: 76.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.865,
    y: 282.875,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 321.05,
    width: 75.69,
    height: 83.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.865,
    y: 362.97,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 404.88,
    width: 75.69,
    height: 96.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.865,
    y: 452.905,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 500.93,
    width: 75.69,
    height: 99.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.865,
    y: 550.515,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.02,
    y: 600.1,
    width: 75.69,
    height: 99.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.865,
    y: 650.0500000000001,
    fontFamily: "Arial"
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.71,
    y: 98,
    width: 73.71,
    height: 109.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.565,
    y: 152.77,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.42,
    y: 98,
    width: 74.24,
    height: 109.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.54,
    y: 152.77,
    fontFamily: "Arial"
  }, "\n        Muskegon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.65,
    y: 98,
    width: 86.65,
    height: 109.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.665000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.97499999999997,
    y: 152.77,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.3,
    y: 98,
    width: 95.07,
    height: 109.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.581428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.83500000000004,
    y: 152.77,
    fontFamily: "Arial"
  }, "\n        Saginaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.37,
    y: 98,
    width: 110.72,
    height: 109.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.171111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.73,
    y: 152.77,
    fontFamily: "Arial"
  }, "\n        Kalamazoo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.09,
    y: 98,
    width: 118.91,
    height: 109.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.256666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.5450000000001,
    y: 152.77,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.71,
    y: 207.55,
    width: 106.94,
    height: 125.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.823333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.18,
    y: 270.54,
    fontFamily: "Arial"
  }, "\n        Ingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.71,
    y: 333.53,
    width: 106.94,
    height: 164.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.882222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.18,
    y: 415.55999999999995,
    fontFamily: "Arial"
  }, "\n        Washtenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.71,
    y: 497.59,
    width: 106.94,
    height: 202.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.277142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.18,
    y: 598.795,
    fontFamily: "Arial"
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.65,
    y: 207.55,
    width: 189.8,
    height: 155.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.55,
    y: 285.145,
    fontFamily: "Arial"
  }, "\n        Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.44,
    y: 207.55,
    width: 262.56,
    height: 155.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.72,
    y: 285.145,
    fontFamily: "Arial"
  }, "\n        Macomb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.65,
    y: 362.74,
    width: 192.74,
    height: 337.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.534285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.02,
    y: 531.37,
    fontFamily: "Arial"
  }, "\n        Oakland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.38,
    y: 362.74,
    width: 259.62,
    height: 337.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 51.924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.19,
    y: 531.37,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.d916c787e57884fcf90b35f862420a88.svg";
export { ForwardRef as ReactComponent };